import { render } from "./QBESavingDialogPersistence.vue?vue&type=template&id=cb827ea2&ts=true"
import script from "./QBESavingDialogPersistence.vue?vue&type=script&lang=ts"
export * from "./QBESavingDialogPersistence.vue?vue&type=script&lang=ts"

import "./QBESavingDialogPersistence.vue?vue&type=style&index=0&id=cb827ea2&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__